import { ChangeDetectorRef, Component, inject, OnInit, signal, ChangeDetectionStrategy, DOCUMENT } from '@angular/core';

import { FAQModel } from '../../../models/layout/faq-model';
import { TranslateService } from '@ngx-translate/core';
import { SeoService } from '../../../Services/SeoService';
import { LocalizationService } from '../../../Services/localization-service';

@Component({
  selector: 'app-faqcomponent',
  imports: [],
  templateUrl: './faqcomponent.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './faqcomponent.scss'
})

export class FAQComponent implements OnInit {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translateService = inject(TranslateService);
  private readonly seoService = inject(SeoService);
  private readonly localizationService = inject(LocalizationService);
  private readonly document = inject(DOCUMENT);


  ngOnInit(): void {
    this.localizationService.getLanguage().subscribe(lang => {
      if (lang != '') {
        const canonicalUrl = `${this.document.location.origin}/${lang}/faq`;
        this.seoService.updateCanonicalUrl(canonicalUrl);
        this.cdr.detectChanges();
      }
    });
  }


  faqModel: FAQModel = {
    title: this.translateService.instant('FAQTitle'),
    description: this.translateService.instant('FAQDescription'),
    items: [
      {
        order: 1,
        question: this.translateService.instant('FAQ-q1'),
        answer: this.translateService.instant('FAQ-a1'),
        open: false
      },
      {
        order: 2,
        question: this.translateService.instant('FAQ-q2'),
        answer: this.translateService.instant('FAQ-a2'),
        open: false
      },
      {
        order: 3,
        question: this.translateService.instant('FAQ-q3'),
        answer: this.translateService.instant('FAQ-a3'),
        open: false
      },
      {
        order: 4,
        question: this.translateService.instant('FAQ-q4'),
        answer: this.translateService.instant('FAQ-a4'),
        open: false
      },
      {
        order: 5,
        question: this.translateService.instant('FAQ-q5'),
        answer: this.translateService.instant('FAQ-a5'),
        open: false
      },
      {
        order: 6,
        question: this.translateService.instant('FAQ-q6'),
        answer: this.translateService.instant('FAQ-a6'),
        open: false
      },
      {
        order: 7,
        question: this.translateService.instant('FAQ-q7'),
        answer: this.translateService.instant('FAQ-a7'),
        open: false
      },
      {
        order: 8,
        question: this.translateService.instant('FAQ-q8'),
        answer: this.translateService.instant('FAQ-a8'),
        open: false
      },
      {
        order: 9,
        question: this.translateService.instant('FAQ-q9'),
        answer: this.translateService.instant('FAQ-a9'),
        open: false
      },
      {
        order: 10,
        question: this.translateService.instant('FAQ-q10'),
        answer: this.translateService.instant('FAQ-a10'),
        open: false
      },
      {
        order: 11,
        question: this.translateService.instant('FAQ-q11'),
        answer: this.translateService.instant('FAQ-a11'),
        open: false
      },
    ]
  };



}